import React from 'react';
import { Col, Row, Container } from 'reactstrap';

const Disclaimer = props => {
  return (
    <Container className={props.className} style={props.style}>
      <Row>
        <Col xs={12} className={'mx-auto'} style={props.styleContent}>
          <p style={{ fontSize: '12px', marginBottom: '0.2rem' }}>
            ©2019 Embark Beyond is a Luxury Travel Agency. JetSuite SuiteKey
            Member, Client and Non-Member** Personal information will only be
            shared by JetSuite with Embark at the direct request of the Member,
            Client or Non-Member for providing Embark services. JetSuite is not
            responsible for goods or services offered or provided by Embark.
          </p>
          <p style={{ fontSize: '11px' }}>
            <i>
              *Non-Member - an individual or corporation that has subscribed to
              JetSuite's "News and Updates" or "Requested Information" via
              JetSuite's web submission forms.
            </i>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/Experiences/Disclaimer/Disclaimer.js